import { Link } from 'gatsby';
import React, { useState, useEffect, useRef } from 'react';
import HomeMobilStyle from '../styles/HomeMobilStyle';

export default function HomeMobil({ pageContent, location }) {
  return <HomeMobilStyle>



<ul className="menu">
          <div className="menu-list">
            <Link to="/realisations"> Réalisations </Link>
            <Link to="/etudes"> Études </Link>
            <Link to="/actualites"> Actualités </Link>
            <Link to="/contact">Contact</Link>
          <Link to="/colophon">Colophon</Link>
          <Link to="/cv">CV</Link>
          <Link to="/biographie">Biographie</Link>
          </div>
        </ul>
  </HomeMobilStyle>;
}
